import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import AlgoliaFactory from '@/model/algolia';

export const fetchNumberOfAllSearchGames = async (context: LogicContext) => {
  const Algolia = AlgoliaFactory({
    ...config.algolia.config,
  });

  const filters = [
    `${config.viewer_country}-${config.viewer_region}`,
    `${config.viewer_country}-EMPTY`,
    'EMPTY',
  ];

  const { numberOfGames } = await Algolia.searchNumberOfAllGames(filters);

  return {
    numberOfAllSearchGames: numberOfGames,
  };
};
